"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthentication = useAuthentication;
var _react = require("react");
var _localToken = require("./local-token");
var _contextTypes = _interopRequireDefault(require("./context-types"));
var _utils = require("./lib/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function useAuthentication() {
  var token = (0, _localToken.getLocalToken)();
  var _useContext = (0, _react.useContext)(_contextTypes["default"]),
    clientId = _useContext.clientId,
    provider = _useContext.provider;
  if (!token) {
    (0, _utils.authorize)(provider, clientId);
    return {
      authenticated: false
    };
  } else {
    return {
      authenticated: true,
      token: token
    };
  }
}
//# sourceMappingURL=useAuthentication.js.map